// tslint:disable-next-line:no-namespace
export namespace Constants {
  export const MENU = [
    {
      url: '/app/dashboard',
      title: 'Dashboard',
      constant: 'DASHBOARD',
    },
    {
      url: '/app/cms',
      title: 'CMS',
      constant: 'CMS',
      children: [
        {
          url: '/app/cms/trader',
          title: 'Trader',
          constant: 'TRADER',
        },
        {
          url: '/app/cms/ib',
          title: 'IB',
          constant: 'IB',
        },
        {
          url: '/app/cms/mam-pamm-follower',
          title: 'MAM/PAMM Follower',
          constant: 'MAM_PAMM_FOLLOWER',
        },
      ],
    },
    {
      url: '/app/affiliate',
      title: 'Affiliate',
      constant: 'AFFILIATE',
      children: [
        {
          url: '/app/affiliate/create',
          title: 'Create Link',
          constant: 'CREATE_LINK',
        },
        {
          url: '/app/affiliate/list',
          title: 'Links',
          constant: 'LINK_CONTROL',
        },
        {
          url: '/app/affiliate/setting',
          title: 'IB Campaign Setting',
          constant: 'IB_CAMPAIGN_SETTING',
          iconType: 'image',
        },
        {
          url: '/app/affiliate/manager',
          title: 'Manage Level Settings',
          constant: 'MANAGER_LEVEL_SETTING',
        },
        {
          url: '/app/affiliate/symbol-list',
          title: 'Manage Level Settings',
          constant: 'SYMBOL_LIST',
        },
        {
          url: '/app/affiliate/create-mt5-account',
          title: 'Create MT5 Account',
          constant: 'CREATE_MT5_ACCOUNT',
        },
        {
          url: '/app/affiliate/ib-ranking',
          title: 'IB Ranking',
          constant: 'IB_RANKING',
        },
        {
          url: '/app/affiliate/default-setting',
          title: 'Default setting',
          constant: 'DEFAULT_SETTING',
        },
      ],
    },
    {
      url: '/app/kyc',
      title: 'KYC',
      constant: 'KYC',
    },
    {
      url: '/app/bonus',
      title: 'BONUS',
      constant: 'BONUS',
      children: [
        {
          url: '/app/bonus/permanent',
          title: 'Permanent bonus',
          constant: 'PERMANENT_BONUS',
        },
        {
          url: '/app/bonus/promotion',
          title: 'Promotion bonus',
          constant: 'PROMOTION_BONUS',
        },
        {
          url: '/app/bonus/manual',
          title: 'Manual bonus',
          constant: 'MANUAL_BONUS',
        },
      ],
    },
    {
      url: '/app/wallet',
      title: 'Wallet',
      constant: 'WALLET',
    },
    {
      url: '/app/platform-settings',
      title: 'Platform Settings',
      constant: 'PLATFORM_SETTINGS',
    },
    {
      url: '/app/user-settings',
      title: 'User Settings',
      constant: 'USER_SETTINGS',
    },
    {
      url: '/app/approval',
      title: 'IB & MAM Approval',
      constant: 'IB_MAM',
    },
    {
      url: '/app/mam-rebate',
      title: 'MAM Rebate',
      constant: 'MAM_REBATE',
    },
    {
      url: '/app/email',
      title: 'Email Marketing',
      constant: 'EMAIL_MARKETING',
      children: [
        {
          url: '/app/email-marketing',
          title: 'All Users under specific ID & Condition',
          constant: 'SPECIFIC_CONDITION',
        },
        {
          url: '/app/email-campaigns',
          title: 'Campaigns',
          constant: 'CAMPAIGNS',
        },
      ]
    },
  ];

  export const PERMISSION_CONSTANT = {
    '/app/cms': 'cms',
    '/app/cms/detail': 'cms',
    '/app/cms/trader': 'cms',
    '/app/cms/ib': 'cms',
    '/app/cms/mam-pamm-follower': 'cms',
    '/app/dashboard': 'dashboard',
    '/app/kyc': 'kyc',
    '/app/affiliate/create': 'affiliate',
    '/app/affiliate/list': 'affiliate',
    '/app/affiliate/setting': 'affiliate',
    '/app/affiliate/manager': 'affiliate',
    '/app/affiliate/symbol-list': 'affiliate',
    '/app/affiliate/create-mt5-account': 'affiliate',
    '/app/affiliate/trading-volumn': 'affiliate',
    '/app/affiliate/ib-ranking': 'affiliate',
    '/app/affiliate/default-setting': 'affiliate',
    '/app/user-settings': 'user_setting',
    '/app/wallet': 'wallet',
    '/app/platform-settings': 'platform_setting',
    '/app/ib': 'ib',
    '/app/bonus': 'bonus',
    '/app/bonus/permanent': 'bonus',
    '/app/bonus/manual': 'bonus',
    '/app/bonus/promotion': 'bonus',
    '/app/ranking': 'ib_ranking',
    '/app/approval': 'ib_mam_approved',
    '/app/mam-rebate': 'mam_rebate',
    '/app/email-marketing': 'email_marketing',
    '/app/email-campaigns': 'email_marketing'
  };

  export const PAGE_WITHOUT_PERMISSION = [];

  export const API_WITHOUT_TOKEN = [
    '/api/login',
    '/api/refresh-token'
  ];
  export const API_DOUBLE_CLICK = [];
  export const MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  export const FILE_DOWNLOAD_TEMPLATE = {
    EXCEL: `<html
              xmlns:o="urn:schemas-microsoft-com:office:office"
              xmlns:x="urn:schemas-microsoft-com:office:excel"
              xmlns="http://www.w3.org/TR/REC-html40">
              <head><!--[if gte mso 9]>
                <xml><x:ExcelWorkbook>
                  <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                      <x:Name>{worksheet}</x:Name>
                      <x:WorksheetOptions>
                        <x:DisplayGridlines/>
                      </x:WorksheetOptions>
                    </x:ExcelWorksheet>
                  </x:ExcelWorksheets>
                  </x:ExcelWorkbook>
                </xml><![endif]-->
                <meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>
              </head>
              <body>
                <table>{table}</table>
              </body>
            </html>`,
  };

  export let COUNTRIES = [];

  export const IGNORE_COUNTRY_EXPORT = [];


  export const CARD_RANKS = [
      { id: 1, name: 'Beginner', image: 'card_beginner.png' },
      { id: 2, name: 'Silver', image: 'card_sliver.png' },
      { id: 3, name: 'Gold', image: 'card_gold.png' },
      { id: 4, name: 'Platinum', image: 'card_platinum.png' },
      { id: 5, name: 'Black', image: 'card_black.png' },
      { id: 6, name: 'Diamond', image: 'card_diamond.png' },
   ];

  export let LABEL_MT4_GROUP = {};

  export const RESPONSE_STATUS = {
    SUCCESS: 1000,
    FAILED: 1001,
    PERMISSION_DENIED: 1002,
  };


  export const RESPONSE_ERROR = {
    INVALID_TOKEN: 501,
    PERMISSION_DENIED: 502,
    EXISTED_USERNAME: 503,
    EXISTED_EMAIL: 504,
    EXISTED_USERNAME_OR_EMAIL: 505,
    SYSTEM_BUSY: 506,
    INVALID_USERNAME_OR_PASSWORD: 507,
    INVAILD_PARAMS: 508,
    REQUEST_EXCEEDED_LIMIT: 509,
    IP_NOT_ALLOWED: 510,
    WRONG_2FA_CODE: 511,
    ENABLED_2FA_CODE: 512,
    USER_HAVE_NO_EMAIL: 513,
    NOT_EXISTED_EMAIL: 514,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
  };

  export const ERROR_MESSAGE = {
    501: 'Invalid Token',
    502: 'Permission Denied',
    503: 'This username has already existed.',
    504: 'This email has already existed.',
    505: 'Username or email has already existed.',
    506: 'System busy',
    507: 'Username or password is invalid',
    508: 'Invalid Params',
    509: 'Request Exceeded Limit',
    510: 'Your IP is not allowed.',
    511: 'The 2FA Code is not correct.',
    512: 'The 2FA Code is enabled.',
    513: 'This user does not have any email.',
    514: 'This email does not exist.',
    612: 'This email does not exist.',
    613: 'This user does not exist in IB tree',
    614: 'User email is Invalid. User email must be User',
    615: 'This trader campaign does not exist.',
    616: 'This email does not active.',
    403: 'Forbidden',
    404: 'Not found',
    519: 'This account has reached the maximum number of accounts, so cannot unsuspend this account.',
    620: 'Invalid campaign name',
    627: 'Invalid time',
    9510019: "Balance not enough",
    953008: "This account {login} is having open position(s) under this group {group}. Please close all positions before switching to another group",
    953010: "An account cannot be moved to a group with different deposit currency. Please check again.",
    605: "The selected time has passed. Please select another end time",
    DEFAULT:'System busy',
    10019:"Not enough money"
  };

  export const customErrorMessage=[953008];

  export const TRANSACTION_STATUS = {
    0: 'Requested',
    1: 'Pending',
    2: 'Success',
    3: 'Error',
    4: 'Rejected',
    5: 'Approved',
  };
  export const KYC_STATUS = {
    '-1': 'Unuploaded',
    0: 'Uploaded',
    1: 'Approved',
    2: 'Rejected'
  };

  export const MANUAL_HISTORY = {
    0: 'On going',
    1: 'Done',
    2: 'Error'
  };

  export const CARD_STATUS = {
    0: 'Pending',
    1: 'Approval',
    2: 'Rejected'
  };
  export const WALLET_COIN = [
    {id: 'btc', name: 'BTC'},
    {id: 'eth', name: 'ETH'},
    {id: 'xrp', name: 'XRP'},
    {id: 'usdt', name: 'USDT'}
  ];
  export const WALLET_OTHER = [
    {id: 'usd', name: 'USD'},
    {id: 'jpy', name: 'JPY'},
  ];

  export const FIXED_NUMBER = {
    btc: '1.8-8',
    eth: '1.3-3',
    xrp: '1.1-1',
    usdt: '1.2-2',
    usd: '1.2-2',
    jpy: '1.0-0',
    percent: '1.3-3',
    per: '1.0-0',
    normal: '1.0-0'
  };
  export const SYMBOL_CURRENCY = {
    usd: '$',
    jpy: '¥'
  }
  export const HWMCHANGE = [
    {
      name: 'HWM',
      value: 'hwm',
      color: '#8EFA3E',
      rgba: ['rgba(250,100,0,.5)', 'rgba(250,100,0,0)'],
      selected: true,
    }
  ];
  export const WALLETCHANGE = [
    {
      name: 'Bank Deposit',
      value: 'bank_deposit',
      color: '#2C349F',
      rgba: ['rgba(250,100,0,.5)', 'rgba(250,100,0,0)'],
      selected: true,
    },
    {
      name: 'Bank Withdraw',
      value: 'bank_withdraw',
      color: '#ADDD16',
      rgba: ['rgba(109,212,0,.5)', 'rgba(109,212,0,0)'],
      selected: true,
    },
    {
      name: 'Wallet',
      value: 'wallet',
      color: '#73dfc7',
      rgba: ['rgba(247,204,0,.5)', 'rgba(247,204,0,0)'],
      selected: false,
    },
  ];
  export const EXCHANGES = [
    {
      name: 'Customer',
      value: 'customer',
      color: '#c6ef7c',
      rgba: ['rgba(250,100,0,.5)', 'rgba(250,100,0,0)'],
      selected: true,
    },
    {
      name: 'Commission',
      value: 'commission',
      color: '#e17b91',
      rgba: ['rgba(250,100,0,.5)', 'rgba(250,100,0,0)'],
      selected: false,
    },
    {
      name: 'Swap',
      value: 'swap',
      color: '#f7b500',
      rgba: ['rgba(109,212,0,.5)', 'rgba(109,212,0,0)'],
      selected: false,
    },
    {
      name: 'Ib Payout',
      value: 'ib',
      color: '#8573e1',
      rgba: ['rgba(81,208,220,.5)', 'rgba(81,208,220,0)'],
      selected: false,
    },
    {
      name: 'Bonus',
      value: 'bonus',
      color: '#2C349F',
      rgba: ['rgba(247,204,0,.5)', 'rgba(247,204,0,0)'],
      selected: false,
    },
    // {
    //   name: 'Withdraw Fee',
    //   value: 'wallet',
    //   color: '#dfb688',
    //   rgba: ['rgba(247,204,0,.5)', 'rgba(247,204,0,0)'],
    //   selected: false,
    // },
    {
      name: 'Total',
      value: 'total',
      color: '#73dfc7',
      rgba: ['rgba(247,204,0,.5)', 'rgba(247,204,0,0)'],
      selected: false,
    },
  ];

  export const SYMBOL_SUFFIX = [
    ".m",
    ".c1",
    "main",
    ".up",
    ".pro",
    ".u",
    ".um",
    ".uc1",
  ]
  ;
  export namespace ChartCommon {
    export const AxisPointerChartOption = {
      lineStyle: {
        type: 'dashed',
      },
    };

    export const TitleTextStyleChartOption = {
      fontSize: '14',
      fontWeight: 'bold',
      color: '#2483c5',
    };

    export const LineChartOption = {
      show: true,
      lineStyle: {
        color: '#31323c',
      },
    };
  }

  export namespace Wallet {
    export const STATUS = ['Pending', 'Approve', 'Success', 'Rejected'];
  }

  export const EMAIL_TYPES = [
    { value: 'admin', name: 'Admin ─ admin@crytograph.finance' },
    { value: 'notice', name: 'Notice ─ notice@crytograph.finance' },
    { value: 'noreply', name: 'No Reply ─ noreply@crytograph.finance' },
    { value: 'support', name: 'Support ─ support@crytograph.finance' },
  ];
  export const IMPORT_ERROR_MESSAGE = {
    101: 'Direct IB reward must be lower or equal to lot amount',
    102: 'Direct IB reward and Preceding level IB reward must be lower or equal to lot amount',
    103: 'File is not in the correct format!',
    104: 'Import file with incorrect data!',
  };
  export const REGEX = {
    ALL_CHARACTER: '^([A-Za-z.]*)+$',
    MT5_ACCOUNT: '^([0-9]*)+$',
    FULL_KATAKANA: '^([ァ-ン]|ー|[ｧ-ﾝﾞﾟ])+$',
    PHONE:'^([+][0-9]*|[0-9])*',
  };
}

export const COUNTRY_CODES = {
  AF: "Afghanistan",
  AX: "Åland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "AndorrA",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, The Democratic Republic of the",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic Of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea, Democratic People'S Republic of",
  KR: "Korea, Republic of",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People'S Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia, The Former Yugoslav Republic of",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "RWANDA",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  CS: "Serbia and Montenegro",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan, Province of China",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
};
